// 9fbef606107a605d69c0edbcd8029e5d
// this functions pertains latest 2 bundles, if any bundle is completed then it will show upcoming latest 2.
const persistArrayLength = (data) => {
  let bundlesCompletedQty = 0;
  let completedBundleIndex;
  data.forEach((item, index) => {
    let totalqty = 0;
    item.items.forEach((it) => {
      totalqty += it.quantity;
    });
    if (totalqty % item.requiredQty === 0) {
      bundlesCompletedQty += 1;
      completedBundleIndex = index;
    }
  });
  if (data.length > 2 && completedBundleIndex > 1) {
    return [data[0], data[1]];
  }
  if (data.length > 2) {
    return [data[0 + bundlesCompletedQty], data[1 + bundlesCompletedQty]];
  }
  return data;
};

export const mapCartDataToBundle = (data) => {
  if (!data) return null;
  const bundlesArr = [];
  data.forEach((item) => {
    if (!item.TCPPromotions) {
      return;
    }
    const promotion = item.TCPPromotions;
    const promoMsg = promotion.split(':')[0];
    const promoQty = promotion.split(':')[1];
    if (bundlesArr.length > 0) {
      const check = bundlesArr.some((chckItem) => {
        return chckItem.bundleId === promoMsg;
      });
      if (check) {
        bundlesArr.forEach((mockItem) => {
          if (mockItem.bundleId === promoMsg) {
            mockItem.items.push(item);
          }
        });
      } else {
        bundlesArr.push({
          bundleId: promoMsg,
          requiredQty: promoQty,
          items: [item],
        });
      }
    } else {
      bundlesArr.push({
        bundleId: promoMsg,
        requiredQty: promoQty,
        items: [item],
      });
    }
  });
  return persistArrayLength(bundlesArr);
};

export const getTrackerState = (state) => {
  return state.BundleTracker && state.BundleTracker.get('isTrackerOpen');
};

export const getBundleData = (state) => {
  return state.BundleTracker && state.BundleTracker.get('bundleData');
};

export const getBundleProducts = (state) => {
  const orderData = state.CartPageReducer.getIn(['orderDetails', 'orderItems']);
  const cartData = orderData && JSON.parse(JSON.stringify(orderData));
  const data =
    cartData &&
    cartData.map((item) => {
      return {
        quantity: item.itemInfo.quantity,
        TCPPromotions: item.miscInfo.TCPPromotions,
        c_TCPimages: item.productInfo.imagePath,
        pdpUrl: item.productInfo.pdpUrl,
      };
    });
  const bundleItemsList = state.BundleTracker && state.BundleTracker.get('bundleData');
  const bundleItems = bundleItemsList && JSON.parse(JSON.stringify(bundleItemsList));
  if (data === undefined) return null;
  if (bundleItems === undefined) return null;

  return mapCartDataToBundle(bundleItems);
};
export const getPromotionsData = (state) => {
  return state && state?.Promotions?.promotionsData;
};
